import { fireLinkTag } from './tagManager';

/**
 * @param {tagBreadcrumbsData} data
 */
function tagBreadcrumbs(data) {
  fireLinkTag({
    event_name: 'breadcrumb clicked',
    breadcrumb_available: data.length.toString(),
    breadcrumb_clicked: data.category,
    breadcrumb_pdp: data.name,
    breadcrumb_position_clicked: data.position.toString(),
  });
}

export default tagBreadcrumbs;
